class TabNavigation extends HTMLElement {
  constructor() {
    super();
    this.tabButtons = [];
  }

  connectedCallback() {
    this.tabButtons = Array.from(this.querySelectorAll("[role='tab']"));
    this.keydownEvent = null;
    window.cachedEvent = null;
    this.addEventListeners();
    this.setInitialFocus();
  }

  addEventListeners() {
    if (!this.keydownEvent) {
      this.keydownEvent = true;
      this.addEventListener('keydown', (event) => this.handleKeydown(event));
    }
  }

  handleKeydown(event) {
    if (window.cachedEvent) return;
    window.cachedEvent = event;
    setTimeout(() => {
      window.cachedEvent = null;
    }, 8);
    const currentIndex = this.tabButtons.findIndex((btn) => document.activeElement === btn);
    if (currentIndex === -1) return;

    let newIndex = currentIndex;
    if (event.key === 'ArrowRight') {
      newIndex = (currentIndex + 1) % this.tabButtons.length;
    } else if (event.key === 'ArrowLeft') {
      newIndex = (currentIndex - 1 + this.tabButtons.length) % this.tabButtons.length;
    }

    if (newIndex !== currentIndex) {
      this.switchTab(newIndex);
    }
  }

  switchTab(newIndex) {
    this.tabButtons[newIndex].click();
  }

  setInitialFocus() {
    const btn = this.querySelector('[data-panel-transition]');
    if (btn) {
      setTimeout(() => {
        btn.focus();
      }, 250);
    }
  }
}

customElements.define('tab-navigation', TabNavigation);
